import { SettingsTab } from "@/components/profile/SettingsTab";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/settings")({
  beforeLoad: ({ context }) => {
    if (!context.user) {
      throw redirect({ to: "/password/login" });
    }
    throw redirect({
      to: "/profile",
      search: { tab: "settings" },
    });
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="min-h-screen bg-background pt-28">
      <div className="container mx-auto max-w-2xl px-4 pb-20">
        <h1 className="mb-8 font-bold text-2xl text-foreground">Ayarlar</h1>
        <SettingsTab />
      </div>
    </div>
  );
}
